module.exports = __webpack_public_path__ + "img/erp-logos_0029_maropost.42a091af.jpg";